const storage = {
  store: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(error);
    }
  },
  get: (key) => {
    try {
      const value = localStorage.getItem(key);
      return JSON.parse(value);
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  delete: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  },
  clear: () => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error(error);
    }
  },
};

export { storage };
